import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { AdminPageProps, Product } from "@/types";
import { Button } from "@/components/ui/button";
import { Field, FieldLabel } from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { useForm, usePage } from "@inertiajs/react";
import { Spinner } from "@/components/ui/spinner";
import { FormEvent } from "react";
import { register_sale_store_product_path } from "@/lib/routes";
import { DialogProps } from "@/types/ui";
import useTranslations from "@/hooks/use-translations";

export default function RegisterSaleProductDialog({
  product,
  open,
  onOpenChange,
}: {
  product: Product;
} & DialogProps) {
  const { current_store } = usePage<AdminPageProps>().props;
  const { t } = useTranslations("shared.components.register_sale_product_dialog");
  const registerSaleProductForm = useForm({ quantity: 1 });

  function onSubmit(event: FormEvent) {
    event.preventDefault();

    registerSaleProductForm.patch(
      register_sale_store_product_path(current_store!.id, product.id),
      {
        invalidateCacheTags: ["stores", current_store!.id ?? ""],
        onSuccess() {
          registerSaleProductForm.resetAndClearErrors();
          onOpenChange(false);
        },
      }
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("title")}</DialogTitle>
        </DialogHeader>

        <form
          id={`register-sale-product-form-${product.id}`}
          onSubmit={onSubmit}
          className="flex-1 flex flex-col gap-5"
        >
          <Field>
            <FieldLabel htmlFor="quantity">{t("shared.fields.quantity")}</FieldLabel>
            <Input
              id="quantity"
              name="product[quantity]"
              type="number"
              step="1"
              placeholder={t("shared.fields.quantity_placeholder")}
              value={registerSaleProductForm.data.quantity}
              onChange={(e) =>
                registerSaleProductForm.setData(
                  "quantity",
                  e.target.valueAsNumber
                )
              }
            />
          </Field>
        </form>

        <DialogFooter>
          <DialogClose asChild>
            <Button
              variant="outline"
              disabled={registerSaleProductForm.processing}
            >
              {t("shared.actions.cancel")}
            </Button>
          </DialogClose>
          <Button
            type="submit"
            form={`register-sale-product-form-${product.id}`}
            disabled={registerSaleProductForm.processing}
          >
            {registerSaleProductForm.processing && <Spinner />}
            {t("submit")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
